import { GridCellParams } from '@mui/x-data-grid-pro';
import { GridCustomColDef } from '../../types';
import { formatPrice } from '../../../utils/helpers';

export const runHistoryColumns: GridCustomColDef[] = [
  {
    field: 'rpm_run_id',
    headerName: 'Run',
    headerAlign: 'left',
    align: 'left',
    cellClassName: 'grey-background',
    minWidth: 100,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    sortable: false,
    filterable: false,
    renderCell: (params: GridCellParams) => `${params?.row?.run?.runMonthAbbreviation} ${params?.row?.run?.runYear}`,
    hideable: false
  },
  {
    field: 'charge_recurring_expected',
    headerName: 'Expected MRC',
    headerAlign: 'right',
    align: 'right',
    minWidth: 120,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    sortable: false,
    filterable: false,
    valueFormatter: (value) => formatPrice(value),
    renderCell: (params: GridCellParams) => (
      <span className={params.value && Number(params.value) < 0 ? 'text-price-red' : ''}>
        {formatPrice(params.value as number)}
      </span>
    )
  },
  {
    field: 'charge_recurring_actual',
    headerName: 'Actual MRC',
    headerAlign: 'right',
    align: 'right',
    minWidth: 120,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    sortable: false,
    filterable: false,
    valueFormatter: (value) => formatPrice(value),
    renderCell: (params: GridCellParams) => (
      <span className={params.value && Number(params.value) < 0 ? 'text-price-red' : ''}>
        {formatPrice(params.value as number)}
      </span>
    )
  },
  {
    field: 'revenue_recurring_expected',
    headerName: 'Expected MRR',
    headerAlign: 'right',
    align: 'right',
    minWidth: 120,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    sortable: false,
    filterable: false,
    valueFormatter: (value) => formatPrice(value),
    renderCell: (params: GridCellParams) => (
      <span className={params.value && Number(params.value) < 0 ? 'text-price-red' : ''}>
        {formatPrice(params.value as number)}
      </span>
    )
  },
  {
    field: 'revenue_recurring_actual',
    headerName: 'Actual MRR',
    headerAlign: 'right',
    align: 'right',
    minWidth: 120,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    sortable: false,
    filterable: false,
    valueFormatter: (value) => formatPrice(value),
    renderCell: (params: GridCellParams) => (
      <span className={params.value && Number(params.value) < 0 ? 'text-price-red' : ''}>
        {formatPrice(params.value as number)}
      </span>
    )
  },
  {
    field: 'revenue_onetime_actual',
    headerName: 'One-Time',
    headerAlign: 'right',
    align: 'right',
    minWidth: 120,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    sortable: false,
    filterable: false,
    valueFormatter: (value) => formatPrice(value),
    renderCell: (params: GridCellParams) => (
      <span className={params.value && Number(params.value) < 0 ? 'text-price-red' : ''}>
        {formatPrice(params.value as number)}
      </span>
    )
  },
  {
    field: 'revenue_spiff_actual',
    headerName: 'SPIFF',
    headerAlign: 'right',
    align: 'right',
    minWidth: 120,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    sortable: false,
    filterable: false,
    valueFormatter: (value) => formatPrice(value),
    renderCell: (params: GridCellParams) => (
      <span className={params.value && Number(params.value) < 0 ? 'text-price-red' : ''}>
        {formatPrice(params.value as number)}
      </span>
    )
  },
  {
    field: 'revenue_trueup_expected',
    headerName: 'Expected True-Up',
    headerAlign: 'right',
    align: 'right',
    minWidth: 120,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    sortable: false,
    filterable: false,
    valueFormatter: (value) => formatPrice(value),
    renderCell: (params: GridCellParams) => (
      <span className={params.value && Number(params.value) < 0 ? 'text-price-red' : ''}>
        {formatPrice(params.value as number)}
      </span>
    )
  },
  {
    field: 'revenue_trueup_actual',
    headerName: 'Actual True-Up',
    headerAlign: 'right',
    align: 'right',
    minWidth: 120,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    sortable: false,
    filterable: false,
    valueFormatter: (value) => formatPrice(value),
    renderCell: (params: GridCellParams) => (
      <span className={params.value && Number(params.value) < 0 ? 'text-price-red' : ''}>
        {formatPrice(params.value as number)}
      </span>
    )
  },
  {
    field: 'commission_item_count',
    headerName: 'Items',
    headerAlign: 'right',
    align: 'right',
    minWidth: 70,
    flex: 0.5,
    type: 'singleSelect',
    valueOptions: [],
    sortable: false,
    filterable: false
  }
];
